<template>
  <div>
    <sFormItem
      prop="additionalFieldId"
      :rules="rules.additionalFieldId"
      style="width: 300px;">
      <span slot="label">{{ $t('AdditionalFields.AdditionalField') }}</span>
      <div
        v-if="disabled"
        class="disable-input">
        {{ currentAdditionalProp.caption }}
      </div>
      <sSelect
        v-else
        class="width-100 mt-1"
        :disabled="disabled"
        :placeholder="$t('Common.Select')"
        :value="valueMutable.Id"
        @update:value="val => updateValue('Id', val)">
        <sOption
          v-for="additionalProp in additionalProps"
          :key="additionalProp.id"
          class="px-8"
          :disabled="disabled"
          :label="additionalProp.caption"
          :value="additionalProp.id">
          <div>
            <div>{{ additionalProp.caption }}</div>
            <sChip
              v-if="additionalProp.typeId"
              class="font-size-12 opacity-8">
              {{ additionalProp.typeId }}
            </sChip>
          </div>
        </sOption>
      </sSelect>
    </sFormItem>
    <sFormItem
      v-if="valueMutable.Id && currentAdditionalProp && currentAdditionalProp.typeId"
      prop="updateTypeField"
      :rules="rules.updateTypeField"
      style="width: 300px;">
      <span slot="label">{{ $t('Automation.Action') }}</span>
      <div
        v-if="disabled"
        class="disable-input">
        {{ $t(`Automation.updateAdditionalField.${valueMutable.UpdateType}`) }}
      </div>
      <sSelect
        v-else
        :key="currentAdditionalProp.typeId"
        class="width-100 mt-1"
        :disabled="disabled"
        filterable
        :placeholder="$t('Common.Select')"
        :value="valueMutable.UpdateType"
        @update:value="val => updateValue('UpdateType', val)">
        <sOption
          v-for="additionalProp in currentUpdateTypes"
          :key="additionalProp"
          class="px-8"
          :disabled="disabled"
          :label="$t(`Automation.updateAdditionalField.${additionalProp}`)"
          :value="additionalProp">
          <div>{{ $t(`Automation.updateAdditionalField.${additionalProp}`) }}</div>
        </sOption>
      </sSelect>
    </sFormItem>

    <sFormItem
      v-if="currentAdditionalProp && currentAdditionalProp.typeId === 'DATE_TIME' && currentComponent"
      prop="updateDateValue"
      :rules="currentComponent.component ? rules.updateDateValue : null"
      style="width: 300px;">
      <component
        :is="currentComponent.component"
        :key="currentAdditionalProp.id"
        v-bind="currentComponent.options"
        :disabled="disabled"
        :use-time="false"
        :value="valueMutable.Props"
        @update:value="setParameters"/>
    </sFormItem>
    <template
      v-else-if="currentAdditionalProp && currentAdditionalProp.id">
      <AdditionalFieldInput
        :key="currentAdditionalProp.id"
        :field="currentAdditionalProp"
        :label="false"
        :rules="rules.updateDateValue"
        validation-prop="updateDateValue"
        @update:value="changeAdditionalField">
        <span>{{ $t('Tenders.Value') }}</span>
      </AdditionalFieldInput>
    </template>
  </div>
</template>
<script>
import automations from 'mixins/automations'
import { additionalFieldsMixin } from 'mixins'
import AdditionalFieldInput from 'components/additional fields/AdditionalFieldInput.vue'
import automationActionDateCheckTime from 'components/automation/actions/dateComponents/automationActionDateCheckTime.vue'
import automationActionDate from 'components/automation/actions/dateComponents/automationActionDate.vue'
import automationActionTime from 'components/automation/actions/dateComponents/automationActionTime.vue'


const defaultModel = {
  Id: null,
  UpdateType: null,
  Props: {}
}

export default {
  name: 'updateAdditionalField',
  mixins: [ automations, additionalFieldsMixin ],
  data() {
    const that = this
    return {
      updateTypes: [
        'setNewValue',
        'increase',
        'decrease',
        'increaseDateByCountOfCalendarDays',
        'increaseDateByCountOfWorkingDays',
        'increaseBySpecificTime',
        'setDate',
        'currentDateTrigger'
      ],
      rules: {
        additionalFieldId: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutable.Id) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },
        updateTypeField: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutable.UpdateType) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          }
        },
        updateDateValue: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that?.valueMutable?.Props?.UpdateValue) {
              callback(new Error(that.$t('Validate.Required')))
            } else {
              callback()
            }
          }
        },
      },
    }
  },
  methods: {
    changeAdditionalField(value) {
      this.updateValue('Props', {
        UpdateValue: value
      })
    },
    setParameters(props) {
      props = JSON.parse(props) || {}
      this.$nextTick(() => {
        this.updateValue('Props', props)
      })
    },
    updateValue(field, value) {
      const result = this.$_.cloneDeep(this.value)
      let resultParameters = this.$_.cloneDeep(this.valueMutable)

      if (field === 'Id' ) {
        resultParameters = {
          Id: value,
          UpdateType: null
        }

        const currentAdditionalProp = this.additionalProps.find(i => i.id === value)

        this.rules.updateValue = this.$_getValidationByType(
          currentAdditionalProp?.typeId,
          currentAdditionalProp.settingValues.some(set => set.settingType == 'REQUIRED' && eval(set.value)
          ))

      } else {
        resultParameters[field] = value
      }
      if (result.UpdateType !== this.value.UpdateType) {
        resultParameters.Props = {}
      }
      result.parameters = JSON.stringify(resultParameters)

      this.$emit('update:value', result)
      this.$nextTick(() => {
        this.$children.forEach(child => {
          if (typeof child.validate === 'function') {
            child.validate()
          }
        })
      })
    },
  },
  computed: {
    currentAdditionalProp() {
      if (!this.valueMutable?.Id) {
        return {}
      }

      return {
        ...this.additionalProps.find(i => i.id === this.valueMutable.Id),
        value: this.valueMutable?.Props?.UpdateValue
      }
    },
    currentUpdateTypes() {
      if (!this.currentAdditionalProp?.typeId) {
        return []
      }
      return this.mixin_updateAdditionalField[this.currentAdditionalProp.typeId].updateTypes
    },
    currentComponent() {
      if (this.currentAdditionalProp?.typeId !== 'DATE_TIME' || !this.valueMutable?.UpdateType) {
        return null
      }
      return this.mixin_updateAutomationDateTypes[this.valueMutable?.UpdateType]
    },
    valueMutable() {
      let result = {}
      if (!this.value?.parameters) {
        result = this.$_.cloneDeep(defaultModel)
      } else {
        try {
          result = JSON.parse(this.value.parameters) || this.$_.cloneDeep(defaultModel)
        } catch {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Automation.ErrorActionParams'),
            showClose: true,
            progress: true,
          })
          result = this.$_.cloneDeep(defaultModel)
        }
      }
      if (!Object.keys(result)?.length) {
        result = this.$_.cloneDeep(defaultModel)
      }
      return result
    }
  },
  components: {
    AdditionalFieldInput,
    automationActionDateCheckTime,
    automationActionDate,
    automationActionTime
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
}
</script>
<style scoped>
  .disable-input {
    background-color: var(--secondary__green_locked);
    border-radius: 31px;
    border: 2px solid var(--main__green_locked);
    color: var(--text-color);
    display: inline-block;
    height: 40px;
    line-height: 38px;
    padding: 0 15px;
    cursor: not-allowed;
    width: 300px;
  }
</style>
